export const getDateRange = (rangeType) => {
  const now = new Date();
  let startDate, endDate;

  switch (rangeType) {
    case "24hours":
      startDate = new Date(now.getTime() - 24 * 60 * 60 * 1000);
      endDate = now;
      break;
    case "lastWeek":
      // Get last Sunday
      const lastSunday = new Date(now);
      lastSunday.setDate(now.getDate() - now.getDay());
      lastSunday.setHours(0, 0, 0, 0);

      // Start of last week (Sunday 7 days before last Sunday)
      startDate = new Date(lastSunday);
      startDate.setDate(lastSunday.getDate() - 7);

      // End of last week (Saturday = last Sunday - 1 day)
      endDate = new Date(lastSunday);
      endDate.setDate(lastSunday.getDate() - 1);
      endDate.setHours(23, 59, 59, 999);
      break;
    case "thisMonth":
      startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      endDate = now;
      break;
    case "lastMonth":
      startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      endDate = new Date(now.getFullYear(), now.getMonth(), 0);
      break;
    case "oneMonth":
      startDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
      endDate = now;
      break;
    case "3months":
      startDate = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000);
      endDate = now;
      break;
    case "6months":
      startDate = new Date(now.getTime() - 180 * 24 * 60 * 60 * 1000);
      endDate = now;
      break;
    case "ytd":
      startDate = new Date(now.getFullYear(), 0, 1);
      endDate = now;
      break;
    case "1year":
      startDate = new Date(now.getTime() - 365 * 24 * 60 * 60 * 1000);
      endDate = now;
      break;
    default:
      return { startDate: null, endDate: null };
  }

  // Add 1 day to endDate to include the entire end day (backend parses date-only strings as midnight)
  const adjustedEndDate = new Date(endDate.getTime() + 24 * 60 * 60 * 1000);
  return {
    startDate: startDate.toISOString().split('T')[0],
    endDate: adjustedEndDate.toISOString().split('T')[0]
  };
};
